import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";


//translations
const resources = {
  // gr: {
  //   translation: translationGr
  // },
  fr: {
    translation: {
      dashboard: "Tableau de bord",
      vvinal: "CALCUL DE LA VALEUR VÉNALE",
      database: "Données de base",
      vehicule: "Véhicules",
      client: "Clients",
      param: "Paramétrage",
      essencee: "essence",
      editvehicule: "Modifier véhicule",
      newvehicule: "Nouvelle véhicule",
      editclient: "Modifier client",
      newclient: "Nouvelle client",
      compteur: "Compteur (Km)",
      entretien: "Entretien",
      age: "Age (Année / Mois)",
      ageYears: "Age (Année)",
      ageMonths: "Age (Mois)",
      
      vehiculef: {
        coefCommercial:"Coefficient commercial (%)",
        documents:"Documents",
        remise:"Remise",
        marque: "Marque",
        type: "Type",
        genre: "Genre",
        modele: "Modèle",
        carburant: "Type carburant",
        numChassis: "N° du chassis",
        nbrCylindres: "Nombre de cylindres",
        puissFiscale: "Puissance fiscale",
        prixAchat: "Prix d'achat",
        cg: "Télécharger carte grise (face 1)",
        cg2:"Télécharger carte grise (face 2)",
        facture: "Télécharger facture d'achat",
        cgFull: "Télécharger carte grise complète",
        photos: "Photos véhicule",
        cin: "Carte d'identité nationale",
        selectedPhotos: "photo(s) sélectionnée(s)",
        dropDocument: "Glisser le document ici",
        dropPhotos: "Glisser les photos ici",
        clickToBrowse: "ou cliquer pour parcourir",
        extractionHint: "Pour une extraction fiable, utilisez un scan ou une photo nette, bien éclairée, sans ombre, avec les quatre coins du document visibles. Une résolution proche de 300 DPI est recommandée.",
        extracting: "Extraction...",
        extractedData: "Données extraites",
        applyAll: "Appliquer tout",
        hide: "Masquer",
        qualityTitle: "Qualité du document à vérifier",
        qualityBody: "Le document a été optimisé automatiquement avant OCR, mais la qualité source peut limiter l'extraction.",
        noExtractedData: "Aucune donnée exploitable n'a été extraite pour ce document.",
        field: "Champ",
        detectedValue: "Valeur détectée",
        apply: "Appliquer",
        extractError: "Erreur lors de l'extraction du document.",
        reform: "Réforme automobile",
        "section_document": "Documents",
        "section_carte_grise": "Carte grise",
        "section_facture": "Facture",
        "section_details": "Informations du véhicule",
        "section_photos": "Photos",
        "section_resume": "Résumé",
        "section_chassis": "Châssis & Identification",
        "section_sinistre": "Déclaration de Sinistre",
        "section_admin": "Données Administratives",
        "section_valeurs": "Valeurs & Évaluation",

        "immatriculation": "Immatriculation",
        "immanterieur": "Immatriculation antérieure",
        "firstMec": "Première mise en circulation",
        "mecMaroc": "M.C. au Maroc",
        "dateSinistre": "Date du sinistre",
        "ageMonths": "Âge (mois)",
        "ageYears": "Âge (années)",
        "etatVehicule": "État du véhicule",
        "usage": "Usage",
        "proprietere": "Propriétaire",
        "prestataire": "Prestataire",
        "compteur": "Compteur",
        "fraisimm": "Frais d'immatriculation",
        "ville": "Ville de réforme",
        "assurance": "Assurance",
        "entretReg": "Entretien avec (Concessionaire / Autre structure / Sans)",
        "valMarche": "Valeur marchande",
        "epave": "Épave obtenue par l'assureur (MAD) – unifier DH/MAD",
        "devis": "Devis"
      },
      
      clientf: {
        raison: "Raison sociale",
        type: "Type"
      },
      parametrage: {
        detailsVehicule:"Détails véhicule",
        prixAchat: "Valeur à neuf (DH TTC)",
        puissFiscale: "Puissance fiscale",
        carburant: "Carburant",
        vehicule: "Choisissez un véhicule",
        diesel: "Diesel",
        percentage: "Pourcentage (Diesel)",
        categorieV: "Catégorie de véhicule",
        puissanceFiscale: "Puissance fiscale",
        essencE: "Pourcentage (Essence)",
        hybrid: "Pourcentage (Hybride)",
        annee1: "Année 1 (%)",
        annee2: "Année 2 (%)",
        annee3: "Année 3 (%)",
        annee4: "Année 4 (%)",
        annee5: "Année 5 (%)",
        annee6: "Après 10 ans (%)",
        coefficiantAbattement: "Coefficient d'abattement qui dépend de l'état du véhicule",
        entretenu: "Entretien régulier entretenu chez le concessionnaire depuis sa MEC jusqu'au jour du sinistre",
        entretenu1: "Entretien chez le concessionnaire puis chez Speedy, FastPro Ex Midas, Point-S, garage agrée et tout structure de réparateur disposant de l'identifiant fiscal et l'ICE",
        idFiscal: "Identifiant fiscal",
        ice: "ICE",
        apartirAnnee3: "à partir de la 3 eme année",
        kmMoyAnnuelD: "Kilométrage moy annuel (DIESEL)",
        kmMoyAnnuelE: "Kilométrage moy annuel (ESSENCE)",
        kmMoyAnnuelH: "Kilométrage moy annuel (Hybride)",
        coefEnPlus: "Coefficient (%)",
        coefEnMoins: "Coefficient (% en moins)",
        coefficiantRelatif: "Coefficient relatif au kilométrage moyen annuel",
        typeEntretien: "Type d'entretien",
        section1: "MATRICE  DE  LA  VALEUR  VENALE  A  DIRE  D'EXPERT ",
        section2: "Coefficient d'abattement qui dépend de l'état du véhicule",
        section3: "Coefficient relatif au kilométrage moyen annuel",
        annee3EV: "à partir de la 3ème année",
        prestataire: "Prestataire",
        categorie: "Catégorie",
        etatVehicule: "Etat véhicule",
        puissanceFiscaleMin: "Puissance fiscale (Min)",
        puissanceFiscaleMax: "Puissance fiscale (Max)"
      },
      action: "Action",
      login: {
        title: "Connectez-vous sur la plateforme EXPERTAUTOEVAL",
        username: "Identifiant",
        password: "Mot de passe",
        rememberme: "Mémoriser le mot de passe",
        forgetpass: "Mot de passe oublié ?",
        welcome: "Bienvenue"
      },
      message: {
        required: "Champ obligatoire",
        extractError: "Une erreur s'est produite lors de l'extraction des données. Veuillez télécharger un fichier clair et lisible pour de meilleurs résultats."
      },
      actions: {
        view:"Voir",
        back: "Retour",
        previous: "Précédent",
        next: "Suivant",
        printRecap: "Imprimer rÃ©cap",
        save: "Enregistrer",
        delete: "Supprimer",
        edit: "Modifier",
        login: "Se connecter",
        logout: "Déconnexion",
        downloadTemp: "Template",
        export: "Exporter",
        upload: "Données",
        close: "Fermer",
        confirm: "Confirmer",
        new: "Créer",
        clear: "Réinitialiser",
        cancel: "Annuler",
        calculer: "Evaluer",
        exporter: "Exporter",
      },
      text: {
        confirmation: "Confirmation",
        msgDelete: "Voulez vous supprimer cette ligne ?",
        errorTitle: "Erreur"
      },
      vvinale: {
        courbeDepreciation: "Courbe de dépréciation",
        VVADEsansCorrectif: "VVADE sans correctif",
        correctifEtatVehicule: "Correctif lié à l'Etat véhicule (β)",
        vvadEavecCorrectif1: "VVADE avec correctif (β)",
        vvadEavecCorrectif2: "VVADE avec correctif (λ)",
        correctifKilometrique: "Correctif kilométrique (λ)",
        correctifTotal: "Correctif Total (β + λ)",
        VVADEavecCorrectifTotal: "VVADE avec correctif Total",
        differenceValeurs: "DIFFERENCE  DES  VALEURS",
        arrondiA: "Arrondie à ",
        epaveObtenueAssureur: "Épave obtenue par l'assureur (MAD) – unifier DH/MAD"

      }
    }
  },
  // it: {
  //   translation: translationIT
  // },
  //  rs: {
  //   translation: translationRS
  // },
  //  sp: {
  //   translation: translationSP
  // },
  eng: {
    translation: {
      Gestpanne: "Issues",
      menu: {
        dashboard: "Dashboard"
      },
      actions: {
        login: "Se connecter",
        logout: "Déconnexion"
      },
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "fr", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: "fr",
    ns: ["translation"],
    defaultNS: "translation",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
